import StatusChip from '@/components/StatusChip'
import { HELP_TEXT } from '@/components/StatusChip/config'

import s from './styles.module.scss'

const StatusCell = (attempts) => {
  // renderCell recibe un objeto params, pero como solo nos interesa el valor, podemos pasar directamente el valor a este componente (params.value)
  return (
    <div>
      {!attempts && <div className={s.noData}>-</div>}
      {attempts?.map((a) => (
        <div className={s.iconContainer} key={a._id}>
          <StatusChip status={a.status} />
          {HELP_TEXT[a.status] && <div className={s.helpText}>{HELP_TEXT[a.status]}</div>}
        </div>
      ))}
    </div>
  )
}

export default StatusCell
